import { Actions } from './actions';
import { ILeadFormSubmittedSuccessfullyAction } from '../types/ILeadFormSubmittedSuccessfullyAction';

export const onOpenLeadFormModal = (
    title: string,
    description: string,
    skipLink?: boolean,
    successAction?: string,
    preSubmitAction?: string,
    externalLeadSubmitFailureAction?: string
) => ({
    type: Actions.OPEN_LEAD_FORM_MODAL,
    payload: {
        title,
        description,
        skipLink,
        successAction,
        preSubmitAction,
        externalLeadSubmitFailureAction
    }
});

export const onCloseLeadFormModal = () => ({
    type: Actions.CLOSE_LEAD_FORM_MODAL
});

export const setLeadFormError = (errorDescription: string) => ({
    type: Actions.SET_LEAD_FORM_MODAL_ERROR,
    payload: {
        errorDescription
    }
});

export const onFirstNameBlur = () => ({
    type: Actions.LEAD_FORM_FIRSTNAME_BLUR
});

export const onLastNameBlur = () => ({
    type: Actions.LEAD_FORM_LASTNAME_BLUR
});

export const onEmailBlur = () => ({
    type: Actions.LEAD_FORM_EMAIL_BLUR
});

export const onPhoneBlur = () => ({
    type: Actions.LEAD_FORM_PHONE_BLUR
});

export const onMessageBlur = () => ({
    type: Actions.LEAD_FORM_MESSAGE_BLUR
});

export const onFormSubmit = () => ({
    type: Actions.LEAD_FORM_SUBMITTED
});

export const leadFormSubmittedSuccess = (currentRoute?: string): ILeadFormSubmittedSuccessfullyAction => ({
    type: Actions.LEAD_FORM_SUBMISSION_SUCCESS,
    payload: {
        currentRoute: currentRoute || ''
    }
});

export const onReinitializeForm = () => ({
    type: Actions.REINITIALIZE_LEAD_FORM
});

export const onLeadFormSubmissionContinue = () => ({
    type: Actions.LEAD_FORM_CONTINUE_SUBMISSION
});

export const dispatchAnalyticsAction = (key, description) => ({
    type: Actions.LEAD_FORM_ANALYTICS_ACTION,
    payload: {
        key,
        description
    }
});

export const checkZipCodes = (zip: string, dealerZip: string) => ({
    type: Actions.USPS_ZIP_REQUEST,
    payload: {
        zip,
        dealerZip
    }
});

export const uspsZipFailure = () => ({
    type: Actions.USPS_ZIP_FAILURE
});

export const uspsZipSuccess = (zipResults) => ({
    type: Actions.USPS_ZIP_SUCCESS,
    payload: zipResults
});

export const uspsZipInitialize = () => ({
    type: Actions.USPS_ZIP_INITIALIZE
});
